import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faFile,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { parseDate } from "../../utils";


function getStatusState(status) {
  let state = { percent: 0 , filledBackground: ['#f37b33', '#eaeaea', '#eaeaea'] };

  if (['IN_REVIEW'].includes(status)) {
    state.percent = 50;
    state.filledBackground = ['#f37b33','#f37b33', '#eaeaea']
  }
  if (['APPROVED'].includes(status)) {
    state.percent = 100;
    state.filledBackground = ['#f37b33','#f37b33', '#f37b33']
  }
  if (['REJECTED'].includes(status)) {
    state.percent = 100;
    state.filledBackground = ['#f53d3d','#f53d3d', '#f53d3d']
  }

  return state
}


function AprobDiv({
  status,
  name,
  createdAt,
  categories
}) {
  const { t } = useTranslation()
  const { percent, filledBackground } = getStatusState(status);

  return (
    <div className="testing-aprob">
      <div className="testing-aprob__header">
        <h4 className="testing-aprob__h4" style={{ fontWeight: "600" }}>
          {name}
        </h4>
      </div>
      <div className="testing-aprob__container">
        <div className="testing-aprob__table">
          <table>
            <tr>
              <th>CREACION DE PLANTILLA</th>
              <th>ESTATUS</th>
              <th>CATEGORIA</th>
            </tr>
            <tr>
              <td>{parseDate(createdAt)}</td>
              <td>{t(`documentStatus.${status}`)}</td>
              <td>{categories?.[0]?.name}</td>
            </tr>
          </table>
        </div>
        <div className="Abogados__Progressbar">
          <ProgressBar
            percent={percent}
            filledBackground={filledBackground[0]}
            unfilledBackground="#eaeaea"
            width={"80%"}
          >
            <Step transition="scale" position={0}>
              {({ accomplished }) => (
                <AprobDivStep 
                  accomplished={accomplished}
                  icon={faPaperPlane}
                  label="Plantilla Enviada"
                  backgroundColor={filledBackground[0]}
                />
              )}
            </Step>
            <Step transition="scale">
              {({ accomplished }) => (
                <AprobDivStep 
                  accomplished={accomplished}
                  icon={faFile}
                  label="En revisión"
                  backgroundColor={filledBackground[1]}
                />
              )}
            </Step>
            <Step transition="scale">
              {({ accomplished }) => (
                <AprobDivStep 
                  accomplished={accomplished}
                  icon={faCheckCircle}
                  label="Aprobada"
                  backgroundColor={filledBackground[2]}
                />
                // <img
                //   style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                //   width="30"
                //   src="https://orig00.deviantart.net/493a/f/2017/095/5/4/raichu_icon_by_pokemonshuffle_icons-db4ryym.png"
                // />
              )}
            </Step>
          </ProgressBar>
        </div>
      </div>
    </div>
  );
}

export default AprobDiv;

function AprobDivStep({ label, icon, accomplished, backgroundColor }) {
  return (
    <div className="AprovCircle__container" >
      <div
        className={
          accomplished
            ? "AprovCircle__icon"
            : "AprovCircle__icon-check"
        }
        style={{backgroundColor}}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
      <p className="Step-AprovDiv-1">{label}</p>
    </div>
  )
}
